import { AmbientPlayer } from '../ambient-player/ambient-player.component'
import './footer.style.scss'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__content">
        <AmbientPlayer />
      </div>
    </footer>
  )
}

export { Footer }
